<span class="sortable-header" (click)="onSortColumn($event)">
    {{ label }}
    <span class="sort-mark" [class.active]="activeSortKey === sortKey">
        <!-- Default state (not active) -->
        <ng-container *ngIf="activeSortKey !== sortKey">
            <svg width="18" height="18" viewBox="0 0 22 22" fill="none">
                <path d="M10.25 9.5H15.5" stroke="#AEAEB2" stroke-linecap="round" />
                <path d="M10.25 12.5H14" stroke="#AEAEB2" stroke-linecap="round" />
                <path d="M10.25 15.5H12.5" stroke="#AEAEB2" stroke-linecap="round" />
                <path d="M10.25 6.5H17.75" stroke="#AEAEB2" stroke-linecap="round" />
                <path
                    d="M7.25 16.1094C6.95508 16.4412 6.17014 17.75 5.75 17.75M5.75 17.75C5.32986 17.75 4.54492 16.4412 4.25 16.1094M5.75 17.75C5.75 15.9926 5.75 15.0074 5.75 13.25"
                    stroke="#AEAEB2" stroke-linecap="round" />
                <path
                    d="M4.25 5.89062C4.54492 5.55876 5.32986 4.25 5.75 4.25M5.75 4.25C6.17014 4.25 6.95508 5.55876 7.25 5.89062M5.75 4.25V13.2552"
                    stroke="#AEAEB2" stroke-linecap="round" />
            </svg>
        </ng-container>

        <!-- Active DESC -->
        <ng-container *ngIf="activeSortKey === sortKey && activeSortOrder === 'desc'">
            <svg width="18" height="18" viewBox="0 0 22 22" fill="none">
                <path d="M10.25 9.5H15.5" stroke="#162642" stroke-linecap="round" />
                <path d="M10.25 12.5H14" stroke="#162642" stroke-linecap="round" />
                <path d="M10.25 15.5H12.5" stroke="#162642" stroke-linecap="round" />
                <path d="M10.25 6.5H17.75" stroke="#162642" stroke-linecap="round" />
                <path
                    d="M7.25 16.1094C6.95508 16.4412 6.17014 17.75 5.75 17.75M5.75 17.75C5.32986 17.75 4.54492 16.4412 4.25 16.1094M5.75 17.75C5.75 15.9926 5.75 15.0074 5.75 13.25"
                    stroke="#162642" stroke-linecap="round" />
                <path
                    d="M4.25 5.89062C4.54492 5.55876 5.32986 4.25 5.75 4.25M5.75 4.25C6.17014 4.25 6.95508 5.55876 7.25 5.89062M5.75 4.25V13.2552"
                    stroke="#162642" stroke-linecap="round" />
            </svg>
        </ng-container>

        <!-- Active ASC -->
        <ng-container *ngIf="activeSortKey === sortKey && activeSortOrder === 'asc'">
            <svg width="18" height="18" viewBox="0 0 22 22" fill="none">
                <path d="M10.25 9.5H14" stroke="#162642" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M10.25 12.5H15.5" stroke="#162642" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M10.25 6.5H12.5" stroke="#162642" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M10.25 15.5H17.75" stroke="#162642" stroke-linecap="round" stroke-linejoin="round" />
                <path
                    d="M7.25 16.1094C6.95508 16.4412 6.17014 17.75 5.75 17.75M5.75 17.75C5.32986 17.75 4.54492 16.4412 4.25 16.1094M5.75 17.75C5.75 15.9926 5.75 15.0074 5.75 13.25"
                    stroke="#162642" stroke-linecap="round" stroke-linejoin="round" />
                <path
                    d="M4.25 5.89062C4.54492 5.55876 5.32986 4.25 5.75 4.25M5.75 4.25C6.17014 4.25 6.95508 5.55876 7.25 5.89062M5.75 4.25V13.2552"
                    stroke="#162642" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
        </ng-container>
    </span>
</span>
